

import { withSize } from 'react-sizeme';
import HomePageHeader from '../components/HomePageHeader';

export default withSize()(HomePageHeader);